import { render, staticRenderFns } from "./trawlbens-corporate.vue?vue&type=template&id=62472fbc&scoped=true"
import script from "./trawlbens-corporate.vue?vue&type=script&lang=js"
export * from "./trawlbens-corporate.vue?vue&type=script&lang=js"
import style0 from "./trawlbens-corporate.vue?vue&type=style&index=0&id=62472fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62472fbc",
  null
  
)

export default component.exports